import { render, staticRenderFns } from "./ClientChatTemplates.vue?vue&type=template&id=5ff95064&scoped=true"
import script from "./ClientChatTemplates.vue?vue&type=script&lang=js"
export * from "./ClientChatTemplates.vue?vue&type=script&lang=js"
import style0 from "./ClientChatTemplates.vue?vue&type=style&index=0&id=5ff95064&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff95064",
  null
  
)

export default component.exports